export default function RadioCircle(props: { selected: boolean }) {
  const { selected } = props;
  return (
    <div className="radio-circle">
      {selected && <div className="radio-inner-circle" />}
    </div>
  );
}
